import { render, staticRenderFns } from "./simOpenYx.vue?vue&type=template&id=a133a27e&scoped=true&"
import script from "./simOpenYx.vue?vue&type=script&lang=js&"
export * from "./simOpenYx.vue?vue&type=script&lang=js&"
import style0 from "./simOpenYx.vue?vue&type=style&index=0&id=a133a27e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a133a27e",
  null
  
)

export default component.exports